export default "__VITE_ASSET__z$5hthuC__"